<template>
  <!-- 耕雲導師說法視頻 -->
  <div class="content">
    <div v-for="(item, index) in videoList" :key="index">
      <div class="contentItem">
        <div class="title">
          {{ $t("numList1")[index] }}、{{ item.videos_title }}
        </div>
        <p class="brief">{{ item.news_from }}</p>
        <p class="source">{{ item.videos_brief }}</p>
        <div class="video">
          <!-- <video width="100%" controls="controls">
            <source :src="item.videos_url" type="video/mp4" />
          </video> -->
          <img
            src="http://www.anhsiangchan.org.tw/uploads/one.png"
            v-if="index === 0 && !videoFlag1"
            alt=""
            class="image1"
            @click="payVideo1"
          />
          <img
            class="open1"
            v-if="index === 0 && !videoFlag1"
            @click="payVideo1"
            src="../../static/img/open.png"
            alt=""
          />
          <img
            class="open2"
            v-if="index === 1 && !videoFlag2"
            @click="payVideo2"
            src="../../static/img/open.png"
            alt=""
          />
          <img
            src="http://www.anhsiangchan.org.tw/uploads/two.png"
            v-if="index === 1 && !videoFlag2"
            alt=""
            class="image1"
            @click="payVideo2"
          />
          <video
            v-if="index === 0 && videoFlag1"
            :src="item.videos_url"
            :controls="true"
            :muted="false"
            autoplay
            id="video1"
          ></video>
          <video
            v-if="index === 1 && videoFlag2"
            :src="item.videos_url"
            :controls="true"
            :muted="false"
            autoplay
            id="video2"
          ></video>
        </div>
        <!-- <div style="text-align: center; margin: 1.7rem">
          <div class="downLoad">
            <div class="downIcon">
              <img src="../../static/img/download.png" alt />
            </div>
            <div download @click="downLoad(item)" class="downText">
              {{ $t("downLoad") }}
            </div>
          </div>
        </div> -->
      </div>

      <barF5></barF5>
    </div>
  </div>
</template>

<script>
import { getCateList, getVideoList } from "../../api/apis";
import barF5 from "../../components/barF5";
export default {
  name: "",
  components: {
    barF5,
  },
  // props: ["cateId"],
  data() {
    return {
      videoList: [],
      // baseUrl: "http://chanxue.b.langqiyun.cn/api/index/fileDownload?",
      baseUrl: "http://www.anhsiangchan.org.tw/api/index/fileDownload?",
      image1: require("../../assets/图片1.png"),
      image2: require("../../assets/图片2.png"),
      videoFlag1: false,
      videoFlag2: false,
    };
  },
  watch: {
    videoFlag1(val) {
      if (val) {
        let that = this;
        that.$nextTick(() => {
          var elevideo = document.getElementById("video1");
          elevideo.addEventListener(
            "ended",
            function () {
              that.videoFlag1 = false;
            },
            false
          );
        });
      }
    },
    videoFlag2(val) {
      if (val) {
        let that = this;
        that.$nextTick(() => {
          var elevideo = document.getElementById("video2");
          elevideo.addEventListener(
            "ended",
            function () {
              that.videoFlag2 = false;
            },
            false
          );
        });
      }
    },
  },
  methods: {
    payVideo1() {
      this.videoFlag1 = true;
    },
    payVideo2() {
      this.videoFlag2 = true;
    },
    downLoad(item) {
      window.location.href =
        this.baseUrl + `url=${item.download_url}&title=${item.videos_title}`;
    },
  },
  created() {
    getCateList().then((res) => {
      let id = res[1][4].id;
      getVideoList(id).then((res) => {
        this.videoList = res;
      });
    });
  },
};
</script>

<style scoped>
.contentItem {
  padding: 0.64rem;
  color: #333333 !important;
}
/* .contentItem h3{
     color:#333333;
} */
.title {
  font-size: 0.8rem;
  line-height: 1.6rem;
  font-size: 0.85rem;
  font-weight: 600;
}

.brief,
.source {
  font-size: 0.69rem;
  line-height: 1.7rem;
  font-size: 0.85rem;
}

.source {
}

.video {
  width: 100%;
  height: 265px;
  position: relative;
}

.image1 {
  position: absolute;
  width: 352px;
  height: 240px;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.image2 {
  position: absolute;
  width: 352px;
  height: 240px;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.open1 {
  position: absolute;
  width: 24px;
  height: 24px;
  z-index: 3;
  top: 80%;
  left: 10%;
  /* transform: translate(-50%, -50%); */
}

.open2 {
  position: absolute;
  width: 24px;
  height: 24px;
  z-index: 3;
  top: 80%;
  left: 10%;
  /* transform: translate(-50%, -50%); */
}

video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  right: 0;
  bottom: 0;
}

.downLoad {
  height: 1.07rem;
  background: rgba(4, 123, 205, 1);
  padding: 0.48rem 1.44rem;
  border-radius: 0.2rem;
  color: #ffffff;
  display: inline;
  margin: 1rem 0rem;
}

.downIcon {
  width: 0.75rem;
  height: 0.75rem;
  /* border-bottom: 1px solid #fff; */
  margin-left: 0.2rem;
  display: inline-block;
}

.downLoad .downText {
  font-size: 0.8rem;
  display: inline-block;
}
</style>